import styled from 'styled-components'
import { StyledInternalLink } from 'theme'

import { FlexCol } from '../styled'

export const StyledLink = styled(StyledInternalLink)`
  display: table-row;
  cursor: pointer;
  transition: background-color 0.2s;

  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.cardBorderSecondary};
  text-decoration: none;
  color: inherit;

  &:last-child {
    border-bottom: none;
  }

  :hover {
    background-color: ${({ theme }) => theme.cardSecondary};
    border-color: ${({ theme }) => theme.cardBorderPrimary};
  }

  // These are necessary to make the Link behave like a tr
  td {
    display: table-cell;
  }
`

export const Row = styled.tr<{ isExpanded?: boolean }>`
  cursor: pointer;
  transition: background-color 0.2s;
  // padding: 0 16px;

  border-bottom: 1px solid;
  border-color: ${({ theme }) => theme.cardBorderSecondary};

  &:last-child {
    border-bottom: none;
  }

  :hover {
    background-color: ${({ theme }) => theme.cardSecondary};
    border-color: ${({ theme }) => theme.cardBorderPrimary};
  }
`

export const StategyBadge = styled.div`
  background-color: ${({ theme }) => theme.cardSecondary};
  width: fit-content;
  color: ${({ theme }) => theme.textSecondary};
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 16px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    font-size: 12px;
  `};
`

export const DataLineItem = styled.div`
  font-size: 14px;
`

export const RangeLineItem = styled(DataLineItem)<{ align?: 'center' | 'flex-start' }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => align ?? 'center'};

  width: 100%;
`

export const RangeText = styled.div`
  /* background-color: ${({ theme }) => theme.deprecated_bg2}; */
  padding: 0.25rem 0;
  font-size: 12px;

  border-radius: 8px;

  color: ${({ theme }) => theme.textPrimary};
  display: flex;
  flex-direction: row;
  align-items: center;
  & > *:not(:last-child) {
    margin-right: 4px;
  }
`

export const ExtentsText = styled.span`
  color: ${({ theme }) => theme.textSecondary};
  font-size: 12px;
  margin-right: 8px;
  ${({ theme }) => theme.mediaWidth.upToSmall`
    display: none;
  `};
`

export const PrimaryPositionIdData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  ${FlexCol} {
    gap: 4px;
  }
`

export const PairText = styled.div`
  font-weight: 500;
  font-size: 14px;
  color: ${({ theme }) => theme.textPrimary};

  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
`

export const GridCol = styled.div`
  display: flex;
  align-items: center;
  overflow: hidden;
`

export const MultiplierTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  // padding: 16px;
  min-width: 220px;
  // box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
  // border: 1px solid ${({ theme }) => theme.backgroundOutline || '#2C3049'};
`

export const MultiplierHeader = styled.div`
  font-size: 16px;
  font-weight: 400;
  color: ${({ theme }) => theme.textPrimary};
  margin-bottom: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`

export const MultiplierDivider = styled.div`
  height: 1px;
  background: ${({ theme }) => theme.backgroundOutline};
  margin-bottom: 12px;
  opacity: 0.6;
`

export const MultipliersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const MultiplierItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 2px 0;
`

export const MultiplierDot = styled.div`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.accentActive || '#4D8FEA'};
`

export const MultiplierText = styled.div`
  font-size: 14px;
  color: ${({ theme }) => theme.textSecondary || '#B0B4D2'};
  font-weight: 500;
`

export const HeaderIcon = styled.div`
  color: ${({ theme }) => theme.accentAction || '#4D8FEA'};
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
`

export const EnhancedStarIcon = styled.div`
  color: ${({ theme, color }) => color || theme.accentAction};
  filter: drop-shadow(0 0 3px rgba(10, 87, 230, 0.5));
  display: flex;
  align-items: center;
  justify-content: center;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
`
export const BonusIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: 4px;
  transition: transform 0.2s ease;
  border-radius: 50%;
  padding: 2px;

  &:hover {
    transform: scale(1.1);
  }
`

export const APRDisplayContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: nowrap;
  width: 100%;
`
